import * as React from "react";
import type { SVGProps } from "react";
const SvgZoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <path
      fill="#000"
      d="M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16v-4h2v4h4v2zm10 0v-2h4v-4h2v4q0 .824-.587 1.413A1.93 1.93 0 0 1 16 18zM0 6V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h4v2H2v4zm16 0V2h-4V0h4q.824 0 1.413.588Q18 1.175 18 2v4zm-7 8q-2.075 0-3.537-1.463Q4 11.075 4 9q0-2.075 1.463-3.537Q6.925 4 9 4t3.537 1.463T14 9t-1.463 3.537T9 14m0-2q1.25 0 2.125-.875A2.9 2.9 0 0 0 12 9q0-1.25-.875-2.125A2.9 2.9 0 0 0 9 6q-1.25 0-2.125.875A2.9 2.9 0 0 0 6 9q0 1.25.875 2.125A2.9 2.9 0 0 0 9 12"
    />
  </svg>
);
export default SvgZoom;
